import { Component, OnInit, TemplateRef, Input, Output, EventEmitter, OnChanges, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { log } from 'util';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PhBhpSelectCategoryComponent } from '../ph-bhp-select-category/ph-bhp-select-category.component';
import { PhBhpFrequentCategoryComponent } from '../ph-bhp-frequent-category/ph-bhp-frequent-category.component';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service'
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ObservationService } from 'src/app/services/observation.service';
import { PhBhpObservationMomentsComponent } from '../ph-bhp-observation-moments/ph-bhp-observation-moments.component';

@Component({
  selector: 'lib-ph-bhp-observe-observation',
  templateUrl: './ph-bhp-observe-observation.component.html',
  styleUrls: ['./ph-bhp-observe-observation.component.css']
})
export class PhBhpObserveObservationComponent implements OnInit {

  /**
  * This handler runs on browser refresh, in that case 'End session' button is not clicked.
    To ensure session end, data session data is stored to be sent later on
  */
  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    this.storeEndSessionData();
  }

  confirmDeletionModal: TemplateRef<any>;
  @ViewChild('endsessionmodal', { static: true }) endsessionmodal: TemplateRef<any>;
  @ViewChild('noObservationsmodal', { static: true }) noObservationsmodal: TemplateRef<any>;

  showindication: boolean = false;
  showcategory: boolean = true;
  @Input() selectedward;
  @Input() selecteddept;
  @Input() selectedcategory;
  @Input() selectedsubcategory;
  @Input() wardID
  @Input() departmentID
  @Input() departmentTypeID
  @Input() createdBy
  @Input() sessionName
  @Input() categoryID
  @Input() subcategoryID
  @Input() activecategory = 0
  @Input() newValue = false;
  @Input() currentDate: any
  @Input() handWashingEnabled
  @Input() iswebKessConnectionEstablished
  @Input() enableHandKissSurveillance
  @Input() showProfessionalSubcategory
  @Input() showAseptictasks
  @Input() observeCount = 0;
  @Input() totalCount = 0;
  @Input() totalCountNotCompleted = 0;
  @Input() existingSession = false;
  @Input() categories: any = [];
  @Input() subcategories: any = [];
  @Input() observations: any = [];
  @Input() observationSessionID = 0;
  @Input() startminutes = 0
  @Input() observationSessionValue: any;
  showQuota: boolean = false;
  quotaDetails: any;
  observedQuotas: number = 0;
  quotaDaysLeft: number = 0;
  sessionActive = false;
  updatesession = false;
  updateobservationSessionID
  updateinstitutionID
  updatewardID
  updatedepartmentID
  updatesessionName
  exportedToCleanHandCampaignDateTime
  migratedDateTime
  updatedcreatedBy
  createdDateTime
  isObserveSaved: boolean = false;
  opencancelmodal: boolean = true;
  observeRightTab;
  newData: boolean = false;
  @Output() childData = new EventEmitter();
  modalRefPopUp: BsModalRef;
  momentCategory
  momentSubCategory
  complianceInstitutionData: any;
  seeObservations = false;
  observationIdToDelete: number;

  interval: any
  timer: number
  display
  totalseconds
  translationKeys: typeof TranslationKeys = TranslationKeys;

  @ViewChild('moments') moments: PhBhpObservationMomentsComponent;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    public modalRef: BsModalRef,
    private layoutService: PHBHPLayoutPackageService,
    private service: PHBHPFeaturePackageObserveObservationService,
    public translate: TranslateService,
    public observationService: ObservationService
  ) { }

  ngOnInit() {
    this.getQuotaDetailForCreateSession()
    this.newValue = false
    this.showindication = true;
    this.observationService.newObservation();
    this.observationService.observationSession = this.observationSessionValue;
    this.momentCategory = this.selectedcategory;
    this.momentSubCategory = this.selectedsubcategory;
    this.display = document.querySelector('#time');
    var displayM = document.querySelector('#time');
    this.startTimer(this.startminutes, this.display, displayM);
    this.activecategory = 0;
    this.service.getComplianceInstitutionData(this.layoutService.institutionID).subscribe((res: any) => {
      this.complianceInstitutionData = res;
    });
    this.observationService.enableEdit = false;
    this.observationService.enableView = false;
  }

  getCompletedObservationsMessage() {

    let completed = this.observationService.observations.filter(x => x.completed).length;
    var translationMessage = this.layoutService.translateText(this.translationKeys.Observation.ObservationCount);
    var finalMessage = translationMessage.replace("{total}", completed);
    return finalMessage;
  }

  getNotCompletedObservationsMessage() {
    let notCompleted = this.observationService.observations.filter(x => !x.completed).length;
    if (notCompleted == 0) return "";
    var translationMessage = this.layoutService.translateText(this.translationKeys.Observation.NotCompleted);
    return translationMessage;
  }

  getQuotaDetailForCreateSession() {
    this.service.getQuotaDetailForCreateSession(this.layoutService.institutionID, this.wardID, this.departmentID).subscribe(res => {
      if (res.quotaID != 0) {
        this.showQuota = true;
        this.quotaDetails = res;
        this.observedQuotas = res.observedQuotas;
        this.quotaDetails.startDateTime = this.layoutService.convertUTCStingToLocalDate(this.quotaDetails.startDateTime);
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date(res.endDateTime);
        var secondDate = new Date();
        this.quotaDaysLeft = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        if (this.quotaDetails.quotaID > 0) {
          this.service.getObservationQuotaCount(this.quotaDetails.quotaID).subscribe((res: any) => {
            this.observationService.observedQuotaCount = res;
          });
        }
      }

    })
  }


  startTimer(duration, display, displayM) {
    let timer = duration;
    this.interval = setInterval(() => {
      const days = Math.floor(timer / (3600 * 24));
      const hours = Math.floor((timer % (3600 * 24)) / 3600);
      const minutes = Math.floor((timer % 3600) / 60);
      const seconds = timer % 60;
      const formattedDays = days.toString().padStart(2, '0');
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
      if (days > 0) {
        display.textContent = `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        displayM.textContent = `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      } else {
        if (hours > 0) {
          display.textContent = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
          displayM.textContent = `:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        } else {
          display.textContent = `${formattedMinutes}:${formattedSeconds}`;
          displayM.textContent = `${formattedMinutes}:${formattedSeconds}`;
        }
      }
      this.totalseconds = (days * 24 * 3600) + (hours * 3600) + (minutes * 60) + seconds;
      timer++;
    }, 1000);
  }


  openconfirmationModal() {
    this.modalRefPopUp.hide();
    this.modalRef.hide();
  }


  EditSession(index, category, subcategory, count, categoryID, subcategoryID) {
    this.opencancelmodal = false;
    this.sessionActive = true
    this.observeRightTab = true;
    this.updatesession = true;
    this.activecategory = index;
    this.newValue = true;
    this.observeCount = count;
    this.momentCategory = category;
    this.momentSubCategory = subcategory;
    this.selectedcategory = category;
    this.selectedsubcategory = subcategory;
    this.subcategoryID = subcategoryID;
    this.categoryID = categoryID;
  }

  endSession() {


    if (!this.observationService.enableView) {
      this.moments.checkObservationInProgress();
    }

    if (!this.moments.saveInProgress && this.observationService.observationsList.length == 0) {
      this.modalRefPopUp = this.modalService.show(this.noObservationsmodal, Object.assign({}, { class: 'w-420', backdrop: false, ignoreBackdropClick: true, keyboard: false }));
      return;
    }

    this.modalRefPopUp = this.modalService.show(this.endsessionmodal, Object.assign({}, { class: 'w-420', backdrop: false, ignoreBackdropClick: true, keyboard: false }));

  }

  navigateToObservationProtocol() {
    this.modalRefPopUp.hide();
    this.router.navigate(['/observe/observeObservationProtocol']);
    this.modalRef.hide();
  }

  openCongratulationModal(congratulationmodal: TemplateRef<any>) {
    this.modalRefPopUp = this.modalService.show(congratulationmodal, Object.assign({}, { class: 'w-420', backdrop: false, ignoreBackdropClick: true, keyboard: false })
    )
  }
  openAlmostModal(almostmodal: TemplateRef<any>) {
    this.modalRefPopUp = this.modalService.show(almostmodal, Object.assign({}, { class: 'w-420', backdrop: false, ignoreBackdropClick: true, keyboard: false })
    )
  }



  confirmEvent(event) {
    this.opencancelmodal = event;
  }




  getCount() {
    const completedObservations = this.observations.filter((obs) => {
      if (!obs.category) return false;
      if (this.showProfessionalSubcategory && !obs.subcategory) return false;
      return true;
    });

    this.totalCount = completedObservations.length;
    this.totalCountNotCompleted = this.observations.length - this.totalCount;
  }

  /**
   * Gets current session data
   */
  private getCurrentSessionData() {
    return {
      observationSessionID: this.updateobservationSessionID || this.observationSessionID,
      institutionID: this.updateinstitutionID || this.layoutService.institutionID,
      wardID: this.updatewardID || this.wardID,
      departmentID: this.updatedepartmentID || this.departmentID,
      sessionName: this.updatesessionName || this.sessionName,
      startDateTime: this.currentDate,
      endDateTime: new Date(),
      migrated: 0,
      migratedBy: 0,
      migratedDateTime: this.migratedDateTime,
      exportedToCleanHandCampaign: 0,
      exportedToCleanHandCampaignBy: 0,
      exportedToCleanHandCampaignDateTime: this.exportedToCleanHandCampaignDateTime,
      createdBy: this.updatedcreatedBy || this.createdBy,
      createdDateTime: this.createdDateTime,
      updatedBy: this.updatedcreatedBy || this.createdBy,
      observedCount: this.observedQuotas || this.observeCount,
      quotaId: (this.quotaDetails) ? this.quotaDetails.quotaID : 0
    }
  }


  /**
   * Stores current session data is local storage.
   */
  private storeEndSessionData() {
    let sessionData = this.getCurrentSessionData();
    localStorage.setItem('observeSessionData', JSON.stringify(sessionData))
  }

  async confirmDeleteObservation($event, observation, confirmDeletionModal) {
    this.observationIdToDelete = observation.observeObservationID ? observation.observeObservationID : observation.observeRequestId;
    this.modalRefPopUp = this.modalService.show(confirmDeletionModal, Object.assign({}, { class: 'w-420', backdrop: false, ignoreBackdropClick: true, keyboard: false }));
  }

  async deleteObservation() {
    this.service.deleteObservation(this.observationIdToDelete, this.createdBy).subscribe(res => {
      let index = this.observationService.observations.findIndex(obs => obs.observeObservationID == this.observationIdToDelete);
      this.observationService.observations.splice(index, 1);
      this.observationService.observationsList = this.observationService.observations.slice().reverse();
      this.observationService.editObservation = {};
      this.observationService.enableEdit = false;
      this.observationService.editID = 0;
      this.moments.updatesession = false;
      this.moments.cancelEdit();
    }, (error) => {
      let index = this.observationService.observations.findIndex(obs => obs.observeRequestId == this.observationIdToDelete);
      this.observationService.observations.splice(index, 1);
      this.observationService.observationsList = this.observationService.observations.slice().reverse();
      this.observationService.editObservation = {};
      this.observationService.enableEdit = false;
      this.observationService.editID = 0;
      this.moments.updatesession = false;
      this.moments.cancelEdit();
    });
  }

  editObservation(event: Event, observation) {
    event.stopPropagation();
    event.preventDefault();

    this.seeObservations = false;

    if (this.observationService.editID == observation.observeObservationID && !this.observationService.enableView) {
      this.observationService.enableEdit = false;
      this.observationService.editID = 0;
      this.observationService.editForm.next({});
      this.moments.cancelEdit();
      this.seeObservations = false
      return;
    }
    this.observationService.enableView = false;
    this.observationService.enableEdit = true;
    this.observationService.editObservation = observation;
    this.observationService.editID = observation.observeObservationID;
    this.observationService.editForm.next(observation);

  }

  viewObservation(event: Event, observation) {
    event.stopPropagation();
    event.preventDefault();

    if (this.observationService.enableEdit) return;
    this.observationService.enableEdit = false;

    if (this.observationService.editID == observation.observeObservationID) {
      this.observationService.enableView = false;
      this.observationService.editID = 0;
      this.observationService.editForm.next({});
      this.moments.cancelEdit();
      this.seeObservations = false
      return;
    }
    this.seeObservations = false;
    this.observationService.enableView = true;
    this.observationService.editObservation = observation;
    this.observationService.editID = observation.observeObservationID;
    this.observationService.editForm.next(observation);

  }

  edit(observation) {

    if (this.observationService.editID == observation.observeObservationID) {
      this.moments.cancelEdit();
      return;
    }
    this.moments.updatesession = true;
    this.observationService.editObservation = observation;
    this.observationService.editForm.next();
  }

  cancelEdit() {
    this.moments.cancelEdit();
  }

  getTime(observation) {
    let observationDate = moment.utc(observation.createdDateTime).local();
    let formatedDate = observationDate.format('HH:mm:ss');
    return formatedDate;
  }

  getCategoryName(categoryId) {
    let category = this.categories.find(x => x.categoryID == categoryId);
    return category.categoryName;
  }

  getSubCategoryName(subCategoryId) {
    let subCategory = this.subcategories.find(x => x.subCategoryID == subCategoryId);
    return this.layoutService.getSubCategoryName(subCategory);
  }

  finishEdit() {
    this.observationService.editObservation = {};
    this.moments.updatesession = false;
  }

  getEndSessionMessage() {
    let completed: any = this.observationService.observationsList.filter(x => x.completed).length;
    let saved: any = this.observationService.observationsList.filter(x => x.saved).length;
    let notCompleted: any = this.observationService.observationsList.filter(x => x.saved && !x.completed).length;
    let notSaved: any = this.observationService.observationsList.filter(x => !x.saved).length;
    let message = '';

    if (completed > 0 && notCompleted == 0 && saved > 0 && notSaved == 0 && completed == saved) {
      message += '<img class="warning_icon" src="assets/icons/icon-success.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.SavedObservations) + '</b><br><br>';
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.StillWantExit)}</p>`;
      message = message.replace('{total}', completed);
    } else if (notCompleted > 0 && notSaved == 0) {
      message += '<img class="warning_icon" src="assets/icons/icon-success.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.SavedObservations) + '</b><br><br>';
      message = message.replace('{total}', completed);
      message += '<img class="warning_icon" src="assets/icons/icon-warning-outline.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.UncompletedObservations) + '</b><br><br>';
      message = message.replace('{total}', notCompleted);
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.NotCompleted)}</p>`;
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.StillWantExit)}</p>`;
    } else if (notCompleted == 0 && notSaved > 0) {
      message += '<img class="warning_icon" src="assets/icons/icon-success.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.SavedObservations) + '</b><br><br>';
      message = message.replace('{total}', completed);
      message += '<img class="warning_icon" src="assets/icons/icon-refresh.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.UnsavedObservations) + '</b><br><br>';
      message = message.replace('{total}', notSaved);
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.NotSaved)}</p>`;
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.StillWantExit)}</p>`;
    } else if (notCompleted > 0 && notSaved > 0) {
      message += '<img class="warning_icon" src="assets/icons/icon-success.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.SavedObservations) + '</b><br><br>';
      message = message.replace('{total}', completed);
      message += '<img class="warning_icon" src="assets/icons/icon-warning-outline.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.UncompletedObservations) + '</b><br><br>';
      message = message.replace('{total}', notCompleted);
      message += '<img class="warning_icon" src="assets/icons/icon-refresh.svg"/>';
      message += '<b class="popup-title">' + this.layoutService.translateText(this.translationKeys.Observation.UnsavedObservations) + '</b><br><br>';
      message = message.replace('{total}', notSaved);
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.NotCompletedNotSaved)}</p>`;
      message += `<p class="popup-text">${this.layoutService.translateText(this.translationKeys.Observation.StillWantExit)}</p>`;
    }

    return message;
  }

  getQuota() {
    return this.observationService.observedQuotaCount;
  }

  refreshObservation(event: Event, observation: any) {
    this.service.createObservation(observation, this.moments.quotaId).subscribe((res: any) => {
      var responseArray = {
        observationValue: {
        }
      }

      responseArray.observationValue = res;
      this.moments.savedDataArray(responseArray);
      this.observationService.observations.find(x => x.observeRequestId == observation.observeRequestId).saved = true;
    }, error => {
      this.observationService.observations.find(x => x.observeRequestId == observation.observeRequestId).saved = false;
    });
  }
}

